import React, { useState } from "react";
import { BarChart2, ClipboardList, FlaskConical } from "lucide-react";
import { useAuth } from "../../auth/context/AuthContext";
import {
  ehMedico,
  ehMultiprofissional,
} from "../../../shared/utils/permissoesCategoria";
import { Paciente } from "../../../types";
import { theme } from "../../../shared/styles/theme";
import AbaAvaliacaoClinica from "../../pacientes/components/AbaAvaliacaoClinica";
import ExamesLaboratoriais from "./ExamesLaboratoriais";

interface ExamesPreTransplanteProps {
  paciente: Paciente;
}

export default function ExamesPreTransplante({
  paciente,
}: ExamesPreTransplanteProps) {
  const { usuarioLogado } = useAuth();
  // B249/AI_111: a sub-aba Avaliação Clínica passa a ser EDITÁVEL no pós-Tx
  // (causa da cirrose / HCC). Gate de papel = espelho da aba principal.
  const avaliacaoSomenteLeitura =
    !ehMedico(usuarioLogado) && !ehMultiprofissional(usuarioLogado);

  // Estado para controlar sub-aba selecionada
  const [subAbaSelecionada, setSubAbaSelecionada] = useState<
    "exames" | "inscricao"
  >("exames");

  return (
    <div
      style={{
        background: "white",
        borderRadius: theme.borderRadius.xl,
        boxShadow: theme.shadows.md,
        padding: "16px",
      }}
    >
      {/* HEADER */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "12px",
        }}
      >
        <h2
          style={{
            fontSize: "16px",
            fontWeight: "600",
            color: theme.gray[800],
            display: "flex",
            alignItems: "center",
            gap: "6px",
            fontFamily: theme.fonts.sans,
            margin: 0,
          }}
        >
          <BarChart2 size={20} style={{ marginRight: "8px" }} /> Pré-Transplante
        </h2>
        <div
          style={{
            background: "#fef3c7",
            padding: "6px 12px",
            borderRadius: theme.borderRadius.lg,
            fontSize: "13px",
            fontWeight: "600",
            color: "#92400e",
            fontFamily: theme.fonts.sans,
          }}
        >
          <ClipboardList size={14} style={{ marginRight: "6px" }} /> Histórico
          pré-transplante
        </div>
      </div>

      {/* SUB-ABAS */}
      <div style={{ display: "flex", gap: "8px", marginBottom: "16px" }}>
        <button
          onClick={() => setSubAbaSelecionada("exames")}
          style={{
            padding: "8px 16px",
            background:
              subAbaSelecionada === "exames"
                ? `linear-gradient(135deg, ${theme.primary[600]} 0%, ${theme.primary[700]} 100%)`
                : theme.gray[100],
            color: subAbaSelecionada === "exames" ? "white" : theme.gray[700],
            border: "none",
            borderRadius: theme.borderRadius.md,
            fontSize: "14px",
            fontWeight: "600",
            cursor: "pointer",
            fontFamily: theme.fonts.sans,
            transition: "all 0.3s",
          }}
        >
          <FlaskConical size={14} style={{ marginRight: "6px" }} /> Exames
          Laboratoriais
        </button>

        <button
          onClick={() => setSubAbaSelecionada("inscricao")}
          style={{
            padding: "8px 16px",
            background:
              subAbaSelecionada === "inscricao"
                ? `linear-gradient(135deg, ${theme.primary[600]} 0%, ${theme.primary[700]} 100%)`
                : theme.gray[100],
            color:
              subAbaSelecionada === "inscricao" ? "white" : theme.gray[700],
            border: "none",
            borderRadius: theme.borderRadius.md,
            fontSize: "14px",
            fontWeight: "600",
            cursor: "pointer",
            fontFamily: theme.fonts.sans,
            transition: "all 0.3s",
          }}
        >
          <ClipboardList size={14} style={{ marginRight: "6px" }} /> Avaliação
          Clínica
        </button>
      </div>

      {/* CONTEÚDO DAS SUB-ABAS */}
      {subAbaSelecionada === "exames" ? (
        // SUB-ABA: EXAMES — B249: tabela editável (reusa o componente de labs)
        <ExamesLaboratoriais paciente={paciente} modoPreForcado />
      ) : (
        // SUB-ABA: AVALIAÇÃO CLÍNICA (somente leitura)
        <AbaAvaliacaoClinica
          pacienteId={paciente.id}
          somenteLeitura={avaliacaoSomenteLeitura}
        />
      )}
    </div>
  );
}
